import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './txnhistory.css';
import '../MoneyTransferComponent/Subtransaction.css';
import FinxPayLogo from "../../assests/images/finxpay.png";
import { Link } from "react-router-dom";
import moment from "moment";
const httpClient = axios.create();

class RecentTransaction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            message: '',
            planTypeList: [],
            selectedPlan: '',
            displayErrorMsg: '',
            showModal: false,
            paymentStatus: '',
            transferredAmount: '',
            orderId: '',
            createdOn: '',
            txnSubOrder: '',
            surcharge: '',
            totalAmount: '',
            debitedFrom: '',
            payRef: '',
            billerId: '',
            consumerNo: '',
            kNo: ''


        }
    }


    componentDidMount() {


    }
    componentWillUnmount() {
    }


    errorMessageCall = (message) => {
        this.setState({
            displayErrorMsg: message
        })
    }


    moDalPrint = (event, txn) => {
        event.preventDefault();
        var paymentStatus = '';
        if (txn.status == '' || txn.status == undefined || txn.status == null) {
            paymentStatus = 'Failed';
        }

        if (txn.status == 'SUCCESS') {
            paymentStatus = 'Success';
        }
        if (txn.status == 'PENDING'
            || txn.status == 'ACCEPTED'
            || txn.status == 'PROCESSING'
            || txn.status == 'HUNG') {
            paymentStatus = 'Pending';
        }
        if (txn.status == 'FAILED'
            || txn.status == 'FAIL'
            || txn.status == 'INTERNAL_FAILURE'
            || txn.status == 'SUCCESS_TO_FAILED'
            || txn.status == 'NOT_FOUND') {
            paymentStatus = 'Failed';
        }
        if (txn.status == 'AUTO_REVERSED'
            || txn.status == 'MANUALLY_REVERSED') {
            paymentStatus = 'Reversed';
        }

        this.setState({
            showModal: true,
            paymentStatus: paymentStatus,
            transferredAmount: (txn.transaction != null && txn.transaction != undefined &&
                txn.transaction != '')
                ? parseFloat(txn.transaction.amount).toFixed(2) :
                '0.00',
            orderId: txn.id != null ? txn.id : 'Unlnown Id',
            createdOn: moment(txn.createdOn).format('DD-MM-YYYY hh:mm:ss'),
            surcharge: (txn.status.toLowerCase() != 'failed' && txn.txnDetails != null) ?
                txn.txnDetails.surcharge != null ?
                    parseFloat(txn.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00',
            totalAmount: parseFloat((txn.transaction.amount) -
                (txn.txnDetails != null ? txn.txnDetails.surcharge : 0)).toFixed(2),
            debitedFrom: this.props.agentInfo.mobile,
            payRef: (txn.paymentRefId != '' && txn.paymentRefId != undefined && txn.paymentRefId != null) ?
                txn.paymentRefId : 'NA',
            billerId: txn.billerTxnId,
            consumerNo: txn.optional != null && txn.optional.customer_number != null &&
                txn.optional.customer_number != '' && txn.optional.customer_number,
            kNo: txn.optional != null && txn.optional.K_NUMBER != null &&
                txn.optional.K_NUMBER != '' && txn.optional.K_NUMBER,

        })
    }

    printdiv = (event) => {
        event.preventDefault();
        var divContents = document.getElementById("print").innerHTML;
        var a = window.open('', '', 'height=500, width=500');
        a.document.write('<html>');
        a.document.write('<body>');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }

    render() {

        return (
            <div id="recenttxn">
                <div class="head">
                    <h3>Recent Transactions</h3>
                    <Link to='/billpay-txn'>
                        <button type="button">View All</button>
                    </Link>

                </div>

                <div class="txn-list" id="recntxn">
                    {this.props.billpayTxnHistory != undefined &&
                        this.props.billpayTxnHistory != 'error' &&
                        this.props.billpayTxnHistory != 'loading' &&
                        this.props.billpayTxnHistory.length > 0 &&
                        this.props.billpayTxnHistory.slice(0, 6).map((txnOrder, index) => (
                            <div
                                // class="txncard grbg" 

                                class={txnOrder.status != null ? (txnOrder.status == 'FAILED'
                                    || txnOrder.status == 'INTERNAL_FAILURE'
                                    || txnOrder.status == 'SUCCESS_TO_FAILED') ? 'txncard rdbg'
                                    : (txnOrder.status == 'PENDING'
                                        || txnOrder.status == 'ACCEPTED'
                                        || txnOrder.status == 'PROCESSING'
                                        || txnOrder.status == 'HUNG'
                                    ) ? 'txncard ylbg'
                                        : (txnOrder.status == 'AUTO_REVERSED'
                                            || txnOrder.status == 'MANUALLY_REVERSED'
                                        ) ? 'txncard ylbg'
                                            : txnOrder.status == 'SUCCESS' &&
                                            'txncard grbg' : 'txncard ylbg'}


                                id={"txnhead" + index}>
                                <div class="txn-basic" data-bs-toggle="collapse" data-bs-target={"#txn" + index}
                                    aria-expanded="false" aria-controls={"#txn" + index}>
                                    <div class="txn-type">
                                        {/* <img src={"images/" + txnOrder.transaction.operator.toLowerCase() + ".png"} alt="Airtel" data-toggle="tooltip" title="Airtel" /> */}
                                        <h5>{(txnOrder.transaction != null && txnOrder.transaction.operator != null) ? txnOrder.transaction.operator : 'NA'}</h5>
                                        <p>{txnOrder.transaction != null ?
                                            (txnOrder.transaction.mobile != null &&
                                                txnOrder.transaction.mobile != undefined &&
                                                txnOrder.transaction.mobile != '') ?
                                                txnOrder.transaction.mobile :
                                                (txnOrder.transaction.customerId != null &&
                                                    txnOrder.transaction.customerId != undefined &&
                                                    txnOrder.transaction.customerId != '') ?
                                                    txnOrder.transaction.customerId : 'NA' : 'NA'}</p>
                                    </div>
                                    <div class="txn-no">
                                        <h6>Order ID: {txnOrder.id != null ?
                                            txnOrder.id : 'NA'}</h6>
                                        <p> {txnOrder.createdOn != null ?
                                            moment(txnOrder.createdOn).format('DD-MM-YYYY HH:mm:ss') : 'NA'}</p>
                                    </div>
                                    <div class="txn-amount">
                                        <h4>₹ {txnOrder.transaction != null ?
                                            txnOrder.transaction.amount != null ?
                                                parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : 'NA'}</h4>
                                        <p
                                            class={txnOrder.status != null ? (txnOrder.status == 'FAILED'
                                                || txnOrder.status == 'INTERNAL_FAILURE'
                                                || txnOrder.status == 'SUCCESS_TO_FAILED') ? 'failed'
                                                : (txnOrder.status == 'PENDING'
                                                    || txnOrder.status == 'ACCEPTED'
                                                    || txnOrder.status == 'PROCESSING'
                                                    || txnOrder.status == 'HUNG'
                                                ) ? 'pending'
                                                    : (txnOrder.status == 'AUTO_REVERSED'
                                                        || txnOrder.status == 'MANUALLY_REVERSED'
                                                    ) ? 'pending'
                                                        : txnOrder.status == 'SUCCESS' ? 'success' :
                                                            'pending'

                                                : 'pending'}>{txnOrder.status != null &&
                                                    (txnOrder.status == 'FAILED'
                                                        || txnOrder.status == 'INTERNAL_FAILURE'
                                                        || txnOrder.status == 'SUCCESS_TO_FAILED') ?
                                                    'Failed' : (txnOrder.status == 'PENDING'
                                                        || txnOrder.status == 'ACCEPTED'
                                                        || txnOrder.status == 'PROCESSING'
                                                        || txnOrder.status == 'HUNG'
                                                    ) ? 'Sucessfully processed' :
                                                        (txnOrder.status == 'AUTO_REVERSED'
                                                            || txnOrder.status == 'MANUALLY_REVERSED'
                                                        ) ? 'Reversed' :
                                                            txnOrder.status == 'SUCCESS' ? 'Succes' :
                                                                txnOrder.status.toUpperCase}</p>
                                    </div>
                                </div>

                                <div id={"txn" + index} class="accordion-collapse collapse"
                                    aria-labelledby={"txnhead" + index} data-bs-parent="#recntxn" data-parent="#recntxn">
                                    <div class="txn-details">

                                        <div class="txn-no">
                                            <h6>Debited from:</h6>
                                            <p>TA - {this.props.agentInfo.mobile}</p>
                                        </div>

                                        <div class="blnc-amount">
                                            <p>TA Balance</p>
                                            <h5>₹ NA</h5>
                                        </div>
                                    </div>

                                    <div class="subtxn">
                                        <h4>Sub Transactions</h4>
                                        <div class={txnOrder.status == 'SUCCESS' ? "subtxn-success" :
                                            (txnOrder.status == 'FAILED'
                                                || txnOrder.status == 'INTERNAL_FAILURE'
                                                || txnOrder.status == 'SUCCESS_TO_FAILED') ? "subtxn-failed" :
                                                (txnOrder.status == 'PENDING'
                                                    || txnOrder.status == 'ACCEPTED'
                                                    || txnOrder.status == 'PROCESSING'
                                                    || txnOrder.status == 'HUNG'
                                                ) ? "subtxn-pending" :
                                                    (txnOrder.status == 'AUTO_REVERSED'
                                                        || txnOrder.status == 'MANUALLY_REVERSED'
                                                    ) ? "subtxn-pending" :
                                                        "subtxn-pending"}>
                                            <div class="subtxnleft">
                                                <div class="subtxntxt">{txnOrder.status == 'SUCCESS' ? "Successful" :
                                                    (txnOrder.status == 'FAILED'
                                                        || txnOrder.status == 'FAIL'
                                                        || txnOrder.status == 'INTERNAL_FAILURE'
                                                        || txnOrder.status == 'SUCCESS_TO_FAILED') ? "Failed" :
                                                        (txnOrder.status == 'PENDING'
                                                            || txnOrder.status == 'ACCEPTED'
                                                            || txnOrder.status == 'PROCESSING'
                                                            || txnOrder.status == 'HUNG'
                                                        ) ? "Sucessfully Processed" :
                                                            (txnOrder.status == 'AUTO_REVERSED'
                                                                || txnOrder.status == 'MANUALLY_REVERSED'
                                                            ) ?
                                                                "Reversed" :
                                                                txnOrder.status.toUpperCase()}</div>
                                                <div class="subtxnid">{txnOrder.id != null ?
                                                    txnOrder.id : 'NA'}
                                                    <span>{txnOrder.createdOn != null ?
                                                        moment(txnOrder.createdOn).format('DD-MM-YYYY HH:mm:ss') : 'NA'}</span>
                                                </div>

                                            </div>
                                            <div class="subamunt">₹{txnOrder.transaction != null ?
                                                txnOrder.transaction.amount != null ?
                                                    parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : 'NA'}</div>
                                        </div>



                                        <div class="orderdetail1">
                                            <div class="txnhead">Order Details</div>
                                            <div class="odramt">
                                                <p>Order Amount <span>₹ {(txnOrder.status.toLowerCase().includes('fail') == false && txnOrder.transaction != null) ?
                                                    txnOrder.transaction.amount != null ?
                                                        parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : '0.00'}</span></p>
                                                <p>Comission <span>₹ {(txnOrder.status.toLowerCase() != 'failed'
                                                    && txnOrder.txnDetails != null) ?
                                                    txnOrder.txnDetails.surcharge != null ?
                                                        parseFloat(txnOrder.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00'}</span></p>
                                            </div>

                                            <div class="ttlamt"><p>Total Amount <span>₹ {parseFloat((txnOrder.transaction.amount) - (txnOrder.txnDetails != null ? txnOrder.txnDetails.surcharge : 0)).toFixed(2)}</span></p></div>
                                        </div>

                                        <div class="tnsfrdetail1">
                                            <div class="txnhead">Withdrawal Details</div>
                                            <div class="odramt">
                                                <p>Withdrawal Amount <span>₹ {(txnOrder.status.toLowerCase().includes('fail') == false && txnOrder.transaction != null) ?
                                                    txnOrder.transaction.amount != null ?
                                                        parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : '0.00'}</span></p>
                                                <p>Comission <span>₹ {(txnOrder.status.toLowerCase().includes('fail') == false &&
                                                    txnOrder.txnDetails != null) ?
                                                    txnOrder.txnDetails.surcharge != null ?
                                                        parseFloat(txnOrder.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00'}</span></p>
                                            </div>

                                            <div class="ttlamt"><p>Total Amount <span>₹ {parseFloat((txnOrder.transaction.amount) - (txnOrder.txnDetails != null ? txnOrder.txnDetails.surcharge : 0)).toFixed(2)}</span></p></div>
                                        </div>
                                    </div>

                                    <div class="txn-btn">
                                        {/* <button type="button" class="retry" onClick={e => this.moneyTransfer(e, txnOrder)}>Repeat</button> */}
                                        {
                                            <button type="button" class="print"
                                                data-bs-toggle="modal"
                                                data-bs-target="#print"
                                                onClick={e => this.moDalPrint(e, txnOrder)}>Print</button>
                                        }


                                    </div>


                                </div>
                            </div>
                        ))}
                    {this.props.billpayTxnHistory == undefined &&
                        <div >
                            No Records found
                        </div>
                    }
                    {this.props.billpayTxnHistory == 'error' &&
                        <div class='valid-error'>
                            Something went wrong,please try later!
                        </div>
                    }
                    {this.props.billpayTxnHistory.length == 0 &&
                        <div >
                            No Recent Records found
                        </div>
                    }
                    {this.props.billpayTxnHistory == 'loading' &&
                        <div >
                            Loading transaction history....
                        </div>
                    }

                </div>

                <div class="modal fade" id="print" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header modhead">
                                <h5 class="modal-title">BillPay Reciept</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="printtable">
                                    <div class="printlogo">
                                        <img src={FinxPayLogo} alt="logo" />
                                    </div>
                                    <table class="table table-striped table-bordered" border="1" border-collapse>
                                        <tbody>
                                            <tr>
                                                <td>Payment Status:</td>
                                                <td><strong>{this.state.paymentStatus}</strong></td>
                                            </tr>
                                            <tr>
                                                <td>Transfer Amount:</td>
                                                <td>₹ {this.state.transferredAmount}</td>
                                            </tr>
                                            {/* <tr>
                                                <td>Comission:</td>
                                                <td>₹ {this.state.surcharge}</td>
                                            </tr> */}


                                            <tr>
                                                <td>Total Amount:</td>
                                                <td>₹ {parseFloat(this.state.totalAmount).toFixed(2)}</td>
                                            </tr>

                                            <tr>
                                                <td>Order Id:</td>
                                                <td>{this.state.orderId}</td>
                                            </tr>

                                            <tr>
                                                <td>Date:</td>
                                                <td>{this.state.createdOn}</td>
                                            </tr>
                                            <tr>
                                                <td>Debited From:</td>
                                                <td>{this.state.debitedFrom}</td>
                                            </tr>
                                            <tr>
                                                <td>Payment Reference Id:</td>
                                                <td>{this.state.payRef}</td>
                                            </tr>
                                            {(this.state.billerId != '' &&
                                                this.state.billerId != undefined &&
                                                this.state.billerId != null) &&
                                                <tr>
                                                    <td>Biller Txn Id:</td>
                                                    <td>{this.state.billerId}</td>
                                                </tr>
                                            }
                                            {(this.state.consumerNo != '' &&
                                                this.state.consumerNo != undefined &&
                                                this.state.consumerNo != null) &&
                                                <tr>
                                                    <td>Consumer No:</td>
                                                    <td>{this.state.consumerNo}</td>
                                                </tr>
                                            }
                                            {(this.state.kNo != '' &&
                                                this.state.kNo != undefined &&
                                                this.state.kNo != null) &&
                                                <tr>
                                                    <td>K_NUMBER:</td>
                                                    <td>{this.state.kNo}</td>
                                                </tr>
                                            }

                                        </tbody>
                                    </table>

                                    {this.state.txnSubOrder != '' &&

                                        <table class="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td colspan="3">Sub Transactions Details:</td>
                                                </tr>
                                                <tr class="table-secondary">
                                                    <td>Transactions ID</td>
                                                    <td>Amount</td>
                                                    <td>Status</td>
                                                    <td>Payment Ref.</td>
                                                </tr>

                                                {this.state.txnSubOrder.map(txRsp => (

                                                    <tr>
                                                        <td>{txRsp.id}</td>
                                                        <td>₹ {parseFloat(txRsp.txnDetails.amount).toFixed(2)}</td>
                                                        <td>{txRsp.status == 'INIT' ? 'Pending' : txRsp.status.substring(0, 1).toUpperCase() +
                                                            txRsp.status.substring(1, txRsp.status.length).toLowerCase()}</td>
                                                        <td>
                                                            {txRsp.paymentRefId}
                                                        </td>
                                                    </tr>
                                                ))
                                                }
                                            </tbody>
                                        </table>
                                    }


                                </div>
                            </div>
                            <div class="modal-footer mdftr">
                                <button type="button" class="btn dbbtn" data-bs-dismiss="modal" onClick={this.printdiv}>Print</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        billpayReduce: { billpayTxnHistory },
        miscReduce: { agentInfo, token }
    }
) => ({
    errorMessage, loginErrorMessage, billpayTxnHistory,
    agentInfo, token
});

export default connect(mapStateToProps, null)(RecentTransaction);
